"use strict";

(function (Drupal) {
  Drupal.behaviors.schoolGridColumn = {
    attach: function attach(context, settings) {
      var schoolItem = document.querySelectorAll('.field--name-school-grid-item > .field__items > .field__item');
      if (!schoolItem.length) {
        return;
      }

      // combat dart layout
      var schoolGridParent = document.querySelector('.block-school-grid-column').closest('.layout-bg-content-container');
      var schoolGridLayout = schoolGridParent.closest('.dart-layout');
      schoolGridParent.classList.add('school-grid-layout');
      schoolGridLayout.style.maxHeight = '100vh';
      schoolGridLayout.style.overflow = 'hidden';
      var imgEffect = function imgEffect(element) {
        element.forEach(function (el) {
          var img = el.querySelector('.school-grid__image');
          el.addEventListener('mouseenter', function () {
            el.classList.add('is-active');
            img.dataset.animation = true;
          });
          el.addEventListener('mouseleave', function () {
            el.classList.remove('is-active');
            setTimeout(function () {
              img.dataset.animation = false;
            }, 150);
          });
        });
      };
      imgEffect(schoolItem);
    }
  };
})(Drupal);